import { H4 } from 'foundations-components/transitional/components/H4';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { View } from 'foundations-components/transitional/components/View';
import { Text } from 'foundations-components/components/Text';
import { getMarketingThemePreference } from 'academy-common-lib/features/publicTheme/themeUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AcademyInfoFooter = ({
  inModal
}) => {
  const {
    isTablet,
    isLaptop
  } = useMediaQuery();
  const isMarketingThemeEnabled = getMarketingThemePreference();
  return /*#__PURE__*/_jsxs(View, {
    color: isMarketingThemeEnabled ? 'text-core-default' : 'text-core-on-fill-default',
    marginBlockStart: '0',
    marginInline: "auto",
    maxInlineSize: "1140px",
    paddingBlockEnd: inModal ? '500' : '1500',
    paddingBlockStart: isLaptop ? '1100' : '1500',
    paddingInline: isTablet ? '500' : '1000',
    textAlign: isTablet ? 'left' : 'center',
    children: [/*#__PURE__*/_jsx(H4, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.certification.academyBlurb.title"
      })
    }), /*#__PURE__*/_jsx(Text, {
      as: "p",
      marginBlockEnd: "600",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.certification.academyBlurb.body"
      })
    })]
  });
};
export default AcademyInfoFooter;